import { Component, OnChanges, SimpleChanges, ViewChild } from '@angular/core';



@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.css']
})
export class VideoComponent implements OnChanges {

  @ViewChild('videoPlayer') videoPlayer;
  src;
  constructor() {
  }

  reloadPage() {
    window.location.reload();
  }

  startVideo() {

    this.videoPlayer.start();
  }
  amp(arg0: string) {
    throw new Error('Function not implemented.');
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
  }

  setVideo(no: number) {
    this.startVideo();
  }
}





